<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'App',
    data(){
      return {
        modal_component:null,
        // root_validate_errors:[],

      }
    }
  }
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  /*@import 'fonts';*/
</style>
